import { render, staticRenderFns } from "./HelpBlock.vue?vue&type=template&id=66dae0c4&scoped=true"
import script from "./HelpBlock.vue?vue&type=script&lang=ts"
export * from "./HelpBlock.vue?vue&type=script&lang=ts"
import style0 from "./HelpBlock.vue?vue&type=style&index=0&id=66dae0c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dae0c4",
  null
  
)

export default component.exports